import './App.css';
import "bootstrap/dist/css/bootstrap.css"
import HomePage from './page/HomePage';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
